import { Barva } from './barva';
import { HodinoveSazby } from './hodinoveSazby';
import { KategorieZarizeni } from './kategorieZarizeni';
import { Interier } from './interier';
import { InterniDruh } from './internidruh';
import { LakDruh } from './lakDruh';
import { OdhadyPracnosti } from './odhadyPracnosti';
import { OdlozenaServisniCinnost } from './odlozenaServisniCinnost';
import { OkruhPp } from './okruhPp';
import { PpDruh } from './ppDruh';
import { PpServiceNr } from './ppServiceNr';
import { PracovniPozice } from './pracovniPozice';
import { TabulkovaPozice } from './tabulkovaPozice';
import { Typ } from './typ';
import { WCas } from './wCas';
import { ZakazkaKorekceTempl } from './zakazkaKorekceTempl';
import { ZarazeniZakazky } from './zarazeniZakazky';
import { Zarizeni } from './zarizeni';
import { ServisniPakety } from './servisniPakety';
import { VolitelnyMaterialSp } from './volitelnyMaterialSP';
import { IndividualniNahradyND } from './individualniNahradyND';
import { VybavaVozidla } from './vybavaVozidla';
import { DruhSP } from './druhSP';
import { ZvlastniNabidky } from './zvlastniNabidky';
import { DruhPozadavku } from './druhPozadavku';

export const menu = {
	name: 'CiselnikDilenske',
	list: [
		{ name: 'PpDruh', route: PpDruh.name },
		{ name: 'PpServiceNr', route: PpServiceNr.name },
		{ name: 'Casw', route: WCas.name },
		{ name: 'SMVaria', route: ZarazeniZakazky.name },
		{ name: 'pVozZavadyText', route: OdlozenaServisniCinnost.name },
		{ name: 'Lakdruh', route: LakDruh.name },
		{ name: 'ZakazkaKorekceTempl', route: ZakazkaKorekceTempl.name },
		{ name: 'Barva', route: Barva.name },
		{ name: 'Tablpoz', route: TabulkovaPozice.name },
		{ name: 'pTyp', route: Typ.name },
		{ name: 'Internidruh', route: InterniDruh.name },
		{ name: 'PracovniPozice', route: PracovniPozice.name },
		{ name: 'Interier', route: Interier.name },
		{ name: 'hodinoveSazby', route: HodinoveSazby.name },
		{ name: 'KatZarizeni', route: KategorieZarizeni.name },
		{ name: 'OkruhyPP', route: OkruhPp.name },
		{ name: 'Zarizeni', route: Zarizeni.name },
		{ name: 'ServisniPakety', route: ServisniPakety.name },
		{ name: 'VolitelnyMaterialSp', route: VolitelnyMaterialSp.name },
		{ name: 'IndividualniNahradyND', route: IndividualniNahradyND.name },
		{ name: 'VybavaVoz', route: VybavaVozidla.name },
		{ name: 'DruhSp', route: DruhSP.name },
		{ name: 'OdhadyPracnosti', route: OdhadyPracnosti.name },
		{ name: 'ZvlastniNabidky', route: ZvlastniNabidky.name },
		{ name: 'DruhPozadavku', route: DruhPozadavku.name },
	],
};
